import { render, staticRenderFns } from "./ManualFerramenta.vue?vue&type=template&id=0cd51801&scoped=true"
import script from "./ManualFerramenta.vue?vue&type=script&lang=js"
export * from "./ManualFerramenta.vue?vue&type=script&lang=js"
import style0 from "./ManualFerramenta.vue?vue&type=style&index=0&id=0cd51801&prod&lang=scss&scoped=true"
import style1 from "./ManualFerramenta.vue?vue&type=style&index=1&id=0cd51801&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd51801",
  null
  
)

export default component.exports